import { errorValidation } from './utils';

/**
 * Validate forms
 */
(() => {
	// Messages
	$("form[name='messages']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'messages[name]': {
				required: true,
			},
			'messages[email]': {
				required: true,
				email: true,
			},
			'messages[message]': {
				required: true,
			},
		},
		messages: {
			'messages[name]': {
				required: window.translations.required,
			},
			'messages[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'messages[message]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
